
if (window.location.pathname === '/cart') {
  // window.location.href = '/checkout';
}

document.addEventListener("DOMContentLoaded", function () {

  const slider = document.querySelector(".ingredients-swiper");

  if (slider){
    new Swiper(slider, {
      slidesPerView: 1.5,
      spaceBetween: 20,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      loop: true,
      dot:false,
      slidesOffsetBefore: 20, // Space before first slide (in px)
      slidesOffsetAfter: 20, 
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesOffsetBefore: 30, // Space before first slide (in px)
          slidesOffsetAfter: 30, 
        },
        1024: {
          slidesPerView: 3.5,
          slidesOffsetBefore: 52, // Space before first slide (in px)
          slidesOffsetAfter: 52, 
        }
      }
    });
  };

  const expertslider = document.querySelector(".expert-slider");

  if (expertslider){
    let expertswiper;

    function initSwiper() {
      if (window.innerWidth <= 768) {
        if (!expertswiper) {
          expertswiper = new Swiper(expertslider, {
            slidesPerView: 1.3,
            spaceBetween: 20,
            loop: true,
            autoplay: {
              delay: 3000
            }
          });
        }
      } else {
        if (expertswiper) {
          expertswiper.destroy(true, true);
          expertswiper = undefined;
        }
      }
    }
    initSwiper();
    window.addEventListener("resize", initSwiper);
  }

  

  

  if (document.querySelector("[data-target-shop-section]") && document.querySelector(".product-card__btn")){
    const triggerElement = document.querySelector("[data-target-shop-section]"); // element you click
    const targetButton = document.querySelector(".product-card__btn");   // button to click
    triggerElement.addEventListener("click", function () {
      // Click the button
      targetButton.click();

      // // Check if mobile
      // const isMobile = window.matchMedia("(max-width: 768px)").matches;

      // if (isMobile) {
      //   // Scroll to bottom smoothly
      //   // window.scrollTo({
      //   //   top: document.body.scrollHeight,
      //   //   behavior: "smooth"
      //   // });
      // }
    });
  };

  function setCheckoutDisabled(disabled) {
    var btn = document.getElementById('checkout');
    if (btn) btn.disabled = disabled;
    // Also cover additional checkout buttons (PayPal, etc.)
    var additionalBtns = document.querySelectorAll('.additional-checkout-buttons button, .additional-checkout-buttons [role="button"]');
    additionalBtns.forEach(function(el) {
      if (disabled) {
        el.setAttribute('aria-disabled', 'true');
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.5';
      } else {
        el.removeAttribute('aria-disabled');
        el.style.pointerEvents = '';
        el.style.opacity = '';
      }
    });
  }

  // Collect all cart-items-component section IDs so Shopify renders them in the response.
  function getFreeGiftSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component'))
      .map(function(el) { return el instanceof HTMLElement ? el.dataset.sectionId : null; })
      .filter(Boolean);
  }

  // Dispatch cart:update with the section HTML from the API response so
  // cart-items-component morphs directly (no extra network fetch needed).
  function triggerCartRefresh(sectionsData) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        sourceId: 'free-gift-refresh',
        data: { sections: sectionsData || {} }
      }
    }));
  }

  document.addEventListener("cart:update", function (event) {
    // Re-enable checkout and exit when our own refresh event fires back
    if (event.detail && event.detail.sourceId === 'free-gift-refresh') {
      setCheckoutDisabled(false);
      return;
    }

    function recode(cart) {
      var carttotal = cart.total_price;
      var freethreshold = Theme.freeItem.threshold;
      var freeitemid = Theme.freeItem.variantId;
      var hasFreeGiftProduct = cart.items.some(function(item) { return item.id == freeitemid; });
      var sectionIds = getFreeGiftSectionIds();
      var sectionsParam = sectionIds.join(',');
      var sectionsUrl = window.location.pathname;

      if (carttotal > freethreshold && !hasFreeGiftProduct) {
        setCheckoutDisabled(true);
        fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({
            items: [{ quantity: 1, id: freeitemid }],
            sections: sectionsParam,
            sections_url: sectionsUrl
          }),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(function(response) { return response.json(); })
        .then(function(data) {
          triggerCartRefresh(data.sections);
        })
        .catch(function(err) {
          console.error('Failed to add free gift', err);
          setCheckoutDisabled(false);
        });

      } else if (carttotal <= freethreshold && hasFreeGiftProduct) {
        setCheckoutDisabled(true);
        fetch('/cart/update.js', {
          method: 'POST',
          body: JSON.stringify({
            updates: { [freeitemid]: 0 },
            sections: sectionsParam,
            sections_url: sectionsUrl
          }),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(function(response) { return response.json(); })
        .then(function(data) {
          triggerCartRefresh(data.sections);
        })
        .catch(function(err) {
          console.error('Failed to remove free gift', err);
          setCheckoutDisabled(false);
        });
      }
    }

    if (event.detail.sourceId == "custom-product-add") {
      // /cart/add.js response doesn't include total_price, so fetch the full cart.
      // Use fetch() instead of jQuery for a lighter request.
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) { recode(cart); });
    } else {
      var cart = event.detail.resource;
      recode(cart);
    }
  });

  
  const nutripopupbtn = document.querySelector('a[href="#nutritionalpopup"]');
  if (nutripopupbtn){
    nutripopupbtn.addEventListener("click", function (e) {
      e.preventDefault();
      const modal = document.querySelector('.nutrition-facts-modal');

      if (modal) {
        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
      }

    });
  }
});


(function () {
    function initProductCardSwipers() {
        document.querySelectorAll('.product-card-swiper').forEach(function (container) {
            if (container.dataset.swiperInit) return;
            container.dataset.swiperInit = 'true';

            var slideCount = container.querySelectorAll('.swiper-slide').length;

            new Swiper(container, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: slideCount > 1,
                grabCursor: true,
                observer: true,
                observeParents: true,
                pagination: {
                    el: container.querySelector('.swiper-pagination'),
                    clickable: true
                },
                // navigation: {
                //     nextEl: container.querySelector('.swiper-button-next'),
                //     prevEl: container.querySelector('.swiper-button-prev')
                // }
            });
        });
    }

    document.addEventListener('DOMContentLoaded', initProductCardSwipers);
    document.addEventListener('shopify:section:load', initProductCardSwipers);
})();